/* src/app/warehousing/pages/report-adjustments/report-adjustments.component.scss */
/*# sourceMappingURL=report-adjustments.component.css.map */
